<script lang="ts">
	import imgDevRoom from "@assets/images/about/dev-room.jpg?webp&h=602&imagetools";
	import imgStudent from "@assets/images/about/student-dev.jpg?webp&w=843&imagetools";
	import imgTesting from "@assets/images/about/testing.jpg?webp&w=843&imagetools";
	import imgCompanyLunch from "@assets/images/career/company-lunch.jpg?webp&w=843&imagetools";
	import imgDavidOnCall from "@assets/images/career/david-on-call.jpg?webp&h=602&imagetools";
	import imgMountains from "@assets/images/career/mountains.jpg?webp&h=602&imagetools";
	import imgNelaRichardCoop from "@assets/images/career/nela-richard-coop.jpg?webp&h=602&imagetools";
	import imgPaintBallCrew from "@assets/images/career/paintball-crew-2023.jpg?webp&h=602&imagetools";
	import imgPubFootball from "@assets/images/career/pub-football.jpg?webp&h=602&imagetools";
	import imgSpeakerJacob from "@assets/images/career/speaker-jacob.jpg?webp&h=602&imagetools";
	import imgTomasRichardFocusing from "@assets/images/career/tomas-richard-focusing.jpg?webp&h=602&imagetools";
	import imgTyson007 from "@assets/images/career/tyson-007.jpg?webp&h=602&imagetools";
	import CareerFormReversedLayout from "@components/CareerFormReversedLayout.svelte";
	import Photogallery from "@components/Photogallery.svelte";
	import Pill from "@components/Pill.svelte";
	import { PillColor, PillSize } from "@components/PillProps.js";
	import Section from "@components/Section.svelte";
	import Ul from "@components/Ul.svelte";
	import { UlSize } from "@components/UlProps.js";
	import Formatted from "@components/common/Formatted.svelte";
	import type { MediaSrc } from "@components/common/MediaSrc.js";
	import Layout from "@components/layout/Layout.svelte";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import type { CareerPositionDetailProps } from "./CareerPositionDetailProps.js";

	const { position }: CareerPositionDetailProps = $props();
	const { tenant } = getGlobalTemplateProps();

	const images: MediaSrc[] = [
		{
			src: imgDevRoom,
			type: "image/webp",
		},
		{
			src: imgDavidOnCall,
			type: "image/webp",
		},
		{
			src: imgTomasRichardFocusing,
			type: "image/webp",
		},
		{
			src: imgTesting,
			type: "image/webp",
		},
		{
			src: imgMountains,
			type: "image/webp",
		},
		{
			src: imgPaintBallCrew,
			type: "image/webp",
		},
		{
			src: imgPubFootball,
			type: "image/webp",
		},

		{
			src: imgCompanyLunch,
			type: "image/webp",
		},
		{
			src: imgSpeakerJacob,
			type: "image/webp",
		},
		{
			src: imgTyson007,
			type: "image/webp",
		},
		{
			src: imgStudent,
			type: "image/webp",
		},
		{
			src: imgNelaRichardCoop,
			type: "image/webp",
		},
	];

	const requirementsItems = position.requirements.map((item) => ({
		title: item.title,
		descItems: (item.descItems ?? []).map((text) => text),
		customNumber: item.customNumber,
	}));
</script>

<Layout>
	<Section hero gridChildren="container-12 md:container-10 xl:container-start-2 xl:container-end-11">
		<div class="flex flex-col gap-10 2xl:items-start 2xl:justify-between">
			<div class="flex flex-col gap-6 lg:max-w-[46rem]">
				<h1 class="text-fstonyx">
					<Formatted text={position.perex} />
				</h1>

				<p class="mb-0 text-base text-fstgrey-200">
					<Formatted text={position.introduction} />
				</p>

				<div class="flex flex-wrap gap-2">
					{#if position.badges?.length}
						{#each position.badges ?? [] as badge, badgeIndex (badgeIndex)}
							<Pill color={PillColor.White} size={PillSize.Small}>
								<Formatted text={badge.text} />
							</Pill>
						{/each}
					{/if}

					{#if position.stackBadges?.length}
						{#each position.stackBadges ?? [] as stackBadge (stackBadge)}
							<Pill color={PillColor.White} size={PillSize.Small}>
								<Formatted text={stackBadge} />
							</Pill>
						{/each}
					{/if}
				</div>
			</div>

			<div class="grid gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-2 2xl:grid-cols-2">
				{#each requirementsItems as requirementsItem (requirementsItem.title)}
					<div class="rounded-2xl p-6 sm:p-8 bg-white">
						<Ul items={[requirementsItem]} size={UlSize.Medium} largeTitle />
					</div>
				{/each}
			</div>
		</div>
	</Section>

	<Section gridChildren="container-12 md:container-10 xl:container-start-2 xl:container-end-11 text-fstonyx">
		<CareerFormReversedLayout {position} headlineClass="leading-[1.2] md:leading-[1]">
			{#snippet headline()}
				<Formatted text="Nech kontakt a přivítáme tě cg[[u nás na kávičce]] " />
			{/snippet}
		</CareerFormReversedLayout>
	</Section>
	<Photogallery class="full-width mb-8" {images} />
</Layout>
